module.exports = __webpack_public_path__ + "img/工艺画-2.a72c05b4.png";